import React from "react";
import Atropos from "atropos/react/atropos-react.esm";
import "atropos/atropos.css";

const AtroposCarousel = ({
  scope,
  role,
  owner,
  title,
  usecase,
  live,
  watchVideo,
  promotionVid,
  poster,
}) => {
  return (
    <>
      <Atropos
        className="my-atropos"
        activeOffset={80}
        shadowScale={1.05}
        highlight={false}
        rotateXMax={5}
        rotateYMax={5}
      >
        <div data-atropos-offset="0" className="video-container">
          <video
            loop={true}
            muted={true}
            autoPlay={true}
            src={promotionVid}
            poster={poster}
            type="video/mp4"
          />
        </div>
        <div data-atropos-offset="2" className="hoverInfos">
          <div className="bar animate__animated animate__slideInRight animate__delay-1s" />
          <p className="description animate__animated animate__slideInRight">
            {scope}
            <br></br>
            <span>{role}</span>
          </p>
          <h1 className="animate__animated animate__slideInRight animate__delay-1s">
            {title}
          </h1>
          <h2 className="animate__animated animate__fadeIn animate__delay-2s">
            {owner}
          </h2>
          <div style={{ display: "inline-grid" }}>
            {usecase && (
              <a
                href={usecase}
                target="_blank"
                className="btn btn-view animate__animated animate__fadeIn animate__delay-2s"
              >
                Visit the project
              </a>
            )}
            {watchVideo && (
              <a
                href={watchVideo}
                target="_blank"
                className="btn btn-view animate__animated animate__fadeIn animate__delay-2s"
              >
                Watch Video
              </a>
            )}
            {live && (
              <a
                href={live}
                target="_blank"
                className="btn btn-view animate__animated animate__fadeIn animate__delay-2s"
              >
                Launch Experiment
              </a>
            )}
          </div>
        </div>
      </Atropos>
      <div className="spacer" data-height="200" />
    </>
  );
};

export default AtroposCarousel;
